export default "__VITE_ASSET__EN1xS6VJ__"